import React from 'react'
import SALink from 'components/SALink'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'
import { SERVICES_DATA } from '../../helpers/constants'
import { updateTradeUrl } from '../../helpers/url'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  const handleClick = (event: React.SyntheticEvent<Record<string, any>>) => {
    event.preventDefault()
    const { section: page } = event.currentTarget.dataset

    if (page === 'artadvisory') {
      const location = addStoreLocaleByCookie('/artadvisory')
      window.location = location
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      updateTradeUrl(`/trade/${page}`, page)
    }
  }

  return (
    <div data-section='services'>
      <p data-type='subtitle'>Art Consulting Services</p>
      <div data-type='item-row'>
        {SERVICES_DATA.map(({ title, image, url, section }) => (
          <SALink href={url} data-type='item' onClick={handleClick} data-section={section}>
            <picture data-type='image'>
              <img
                width='240'
                height='240'
                itemProp='image'
                className='lazyload'
                data-src={image}
                alt='services'
                role='presentation'
                data-type='image'
              />
            </picture>
            <p>{title}</p>
          </SALink>
        ))}
      </div>
    </div>
  )
}

export default Component
